"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SourceProviders = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _DynamicSourceProvider = require("./DynamicSourceProvider");
var _StepsSourceProvider = require("./StepsSourceProvider");
var _CallSourceProvider = require("./CallSourceProvider");
var _FeeSourceProvider = require("./FeeSourceProvider");
var _JsonSourceProvider = require("./JsonSourceProvider");
var _UniswapSourceProvider = require("./UniswapSourceProvider");
var _OtherSourceProvider = require("./OtherSourceProvider");
var _LiteralSourceProvider = require("./LiteralSourceProvider");
class SourceProviders {
  constructor() {
    (0, _defineProperty2.default)(this, "sourceTypes", {});
  }
  addSourceType(type) {
    this.sourceTypes[type.name] = type;
    return this;
  }
  valueForSource(provider, source, arg, step) {
    let type = this.sourceTypes[source.type];
    if (type) {
      try {
        return type.getValue(provider, source.parameters, arg, step);
      } catch (err) {
        console.error(`Error getting value for argument source: ${source.type}`, err);
        return {
          annotation() {
            return '<span class="error">There was an error reading the value, please try again later. Contact us if this issue persists.</span>';
          },
          value() {
            return null;
          }
        };
      }
    }
    console.error(`Unrecognized type in valueForSource: ${source.type}`);
    return null;
  }
}
exports.SourceProviders = SourceProviders;
const defaultSourceProviders = new SourceProviders().addSourceType(new _LiteralSourceProvider.LiteralSourceProvider()).addSourceType(new _DynamicSourceProvider.DynamicSourceProvider()).addSourceType(new _StepsSourceProvider.StepsSourceProvider()).addSourceType(new _CallSourceProvider.CallSourceProvider()).addSourceType(new _FeeSourceProvider.FeeSourceProvider()).addSourceType(new _JsonSourceProvider.JsonSourceProvider()).addSourceType(new _UniswapSourceProvider.UniswapSourceProvider()).addSourceType(new _OtherSourceProvider.OtherSourceProvider());
var _default = exports.default = defaultSourceProviders;
//# sourceMappingURL=SourceProviders.js.map